import type { IAbstractFeature } from '../constants'

export interface Plugin extends IAbstractFeature {
  type: 'plugin'
  size: 'full' | 'size-5' | 'size-8'
  tags: string[]
  desc: string
}

export const PLUGINS: Plugin[] = [
  {
    id: 'plugin-openai',
    type: 'plugin',
    title: 'Open AI',
    image: '/logos/openai.png',
    size: 'full',
    tags: ['AI Model', 'NLP'],
    desc: "OpenAI's GPT-4o-mini model for chat conversations. Useful for generating smart AI responses in chat applications. Good for complex tasks",
    prompt: 'Please use OpenAI plugin for the translation feature',
    detect:
      'usage of OpenAI LLM, e.g model: gpt-4o-mini, model: gpt-4o, API call like openai.chat.completions.create()',
  },
  {
    id: 'plugin-elevenlabs',
    type: 'plugin',
    title: 'ElevenLabs AI Voice',
    image: '/logos/elevenlabs.svg',
    size: 'size-8',
    tags: ['AI Voice'],
    desc: "Eleven Labs' multilingual text-to-speech model. Useful for converting text to speech in multiple languages. Supports a wide range of tones",
    prompt: 'Please use ElevenLabs AI Voice to generate the podcast audio',
    detect: 'usage of ElevenLabs text-to-speech AI model',
  },
  {
    id: 'plugin-mythomax',
    type: 'plugin',
    title: 'MythoMax (via Openrouter)',
    image: '/logos/openrouter.png',
    size: 'full',
    tags: ['NLP'],
    desc: "Openrouter's MythoMax model for chat conversations. Useful for roleplay and storytelling, making it well-suited for roleplay and creative story generation",
    prompt: 'Please use MythoMax model for the roleplay feature',
    detect:
      'usage of Openrouter LLM, e.g model: openrouter/gryphe/mythomax-l2-13b',
  },
  {
    id: 'plugin-minimax',
    type: 'plugin',
    title: 'Minimax LLM',
    image: '/logos/minimax.png',
    size: 'size-5',
    tags: ['Language Model'],
    desc: "Minimax's ABAB6.5s model for chat conversations. Useful for generating human-like text responses in chat applications. Good for human-like chat.",
    prompt: 'Please use Minimax LLM plugin for the translation feature',
    detect:
      'usage of Minimax LLM, excluding usage of Minimax AI Voice/Video Generation',
  },
  {
    id: 'plugin-llama',
    type: 'plugin',
    title: 'Llama',
    image: '/logos/llama.png',
    size: 'size-5',
    tags: ['Machine Learning'],
    desc: 'Open-source LLM for cheaper cost',
    prompt: 'Please use Llama plugin for the translation feature',
    detect: 'usage of Llama LLM',
  },
  {
    id: 'plugin-minimax-ai-voice',
    type: 'plugin',
    title: 'AI Voice Generation',
    image: '/logos/minimax.png',
    size: 'size-5',
    tags: ['AI Voice'],
    desc: "Minimax's speech-01-turbo model for speech synthesis. Useful for converting text to speech with a turbo speed, ideal for real-time applications.",
    prompt:
      'Please use Minimax AI Voice Generation to generate the podcast audio',
    detect: 'usage of Minimax AI Voice Generation',
  },
  {
    id: 'plugin-minimax-ai-video',
    type: 'plugin',
    title: 'AI Video Generation',
    image: '/logos/minimax.png',
    size: 'size-5',
    tags: ['AI Video'],
    desc: "Minimax's video-01 model for video generation. Useful for generating video content based on text inputs, but takes longer time.",
    prompt: 'Please use Minimax AI Video Generation to generate video content',
    detect: 'usage of Minimax AI Video Generation',
  },
  {
    id: 'plugin-flux-image',
    type: 'plugin',
    title: 'Flux AI Image Generation',
    image: '/logos/flux.png',
    size: 'full',
    tags: ['AI Image'],
    desc: 'Useful for generating images based on text inputs quickly',
    prompt:
      'Please use Flux AI Image Generation Plugin to create the lego photos from text ',
    detect: 'usage of Flux AI Image Generation',
  },
  {
    id: 'plugin-firecrawl',
    type: 'plugin',
    title: 'Firecrawl Scraper',
    image: '/logos/firecrawl.png',
    size: 'size-5',
    tags: ['Web Scraping'],
    desc: 'A high-performance web scraping tool designed for scraping websites',
    prompt:
      'Please use Firecrawl Scraper API to scrape the following websites: www.techcrunch.com',
    detect: 'usage of Firecrawl Scraper',
  },
  {
    id: 'plugin-perplexity',
    type: 'plugin',
    title: 'Perplexity Search',
    image: '/logos/perplexity.png',
    size: 'full',
    tags: ['AI Search'],
    desc: "Perplexity's AI search API that quickly finds and explains answers",
    prompt:
      'Please use Perplexity Search plugin to find the NBA game scores of the past 7 days ',
    detect: 'usage of Perplexity Search',
  },
]
